import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';

import NoContent from '../NoContent';
import UserTeamRow from './UserTeamRow';

import type { User } from 'API';

import './_styles.scss';

interface UsersTeamTableProps {
    openDialogInfo: () => void;
    users: User[];
    selectedUserIds: string[];
    onToggleUser: (id: string) => void;
}

const UsersTeamTable = ({ users, openDialogInfo, selectedUserIds, onToggleUser }: UsersTeamTableProps) => {
    const tableHeaders: Record<string, React.ReactNode> = {
        firstName: 'First name',
        lastName: 'Last name',
        email: 'E-mail',
        phoneNumber: 'Phone',
        country: 'Country',
        city: 'City',
        role: (
            <>
                Role
                <span
                    className='rioglyph rioglyph-info-sign text-15 ml-5 cursor-pointer text-gray-dark'
                    onClick={openDialogInfo}
                />
            </>
        ),
        status: 'Status',
        created: 'Created',
    };

    const selectAll = () => {
        users.filter(u => !selectedUserIds.includes(u.id)).map(res => onToggleUser(res.id));
    };

    const deselectAll = () => {
        users.filter(u => selectedUserIds.includes(u.id)).map(res => onToggleUser(res.id));
    };

    const dropdownItems = [
        {
            value: <p className='UsersTeamTable__dropdownItemIcons'>Select all users</p>,
            onSelect: selectAll,
        },
        {
            value: <p className='UsersTeamTable__dropdownItemIcons'>Deselect all users</p>,
            onSelect: deselectAll,
        },
    ];

    if (!users?.length) {
        return (
            <NoContent
                title='No users yet, but they will appear here'
                body='You can go to the users tab and create a new user.'
            />
        );
    }

    return (
        <div className='UsersTeamTable'>
            <table data-testid='exceptions-table' className='table-head-filled table-bordered table'>
                <thead>
                    <tr>
                        <th className='UsersTeamTable__headerIcon'>
                            <ButtonDropdown
                                title={<span className='rioglyph rioglyph-checkboxes UsersTeamTable__rioIcon' />}
                                items={dropdownItems}
                                bsStyle='muted'
                                iconOnly
                                dropup
                                noCaret
                                className='UsersTeamTable__dropbutton'
                            />
                        </th>
                        {Object.entries(tableHeaders).map(([colKey, label]) => (
                            <th key={colKey}>{label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {users.map(_ => (
                        <UserTeamRow
                            key={_.id}
                            user={_}
                            checked={selectedUserIds.includes(_.id)}
                            onChange={onToggleUser}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UsersTeamTable;
